import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {NotificationDeterminant} from "../../models/notification-determinant";
import Helpers from "../../utils/helpers";

@Injectable()
export class NotificationDeterminantControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getNotificationDeterminant(notificationId: string): Observable<NotificationDeterminant> {
    return this.http.get(this.baseUrl + "notification/determinantgroup/" + notificationId) as Observable<NotificationDeterminant> ;
  }

  public createNotificationDeterminant(notificationId: string, notification: any) {
    Helpers.trimRecursiveObj(notification);
    const body = JSON.stringify(notification);
    return this.http.post(this.baseUrl + "notification/" + notificationId + "/notification", body);
  }

  public saveNotificationDeterminantGroup<T>(group: any) {
    Helpers.trimRecursiveObj(group);
    const body = JSON.stringify(group);
    return this.http.put(this.baseUrl + "notification/determinantgroup", body, {responseType: "text"});
  }

  public saveNotificationDeterminantGroups(notificationId: string, group: any) {
    Helpers.trimRecursiveObj(group);
    const body = JSON.stringify(group);
    return this.http.put(this.baseUrl + "notification/" + notificationId + "/determinantgroup", body, {responseType: "text"});
  }

  public deleteDeterminant<T>(groupId: string) {
    return this.http.delete(this.baseUrl + "notification/determinantgroup/" + groupId, {responseType: "text"});
  }

}
